import template from './sw-cms-block-product-description-reviews.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
